// Single source of truth for the version of the legal documents users see
// and consent to. Bump the version + last_updated whenever the wording of
// /privacy or /terms changes — this drives the signup consent record and
// the "Last Updated" strap on the public pages.

export const PRIVACY_VERSION = '1.0.0';
export const PRIVACY_LAST_UPDATED = 'February 1, 2026';

export const TERMS_VERSION = '1.0.0';
export const TERMS_LAST_UPDATED = 'February 1, 2026';

// App version. Read from CRA build env if provided; otherwise falls back to
// the package.json version (injected at build time).
export const APP_VERSION =
  process.env.REACT_APP_VERSION ||
  process.env.REACT_APP_BUILD_VERSION ||
  'web';
